var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('pui-modal-dialog-form',{attrs:{"overflow":false,"titleText":_vm.$t('modifnotif.action'),"modelName":_vm.modelName,"dialogName":_vm.dialogNameModifNotif,"widthDialog":800,"onOk":_vm.onOkModifNotif}},[_c('template',{slot:"message"},[_c('v-container',[_vm._v(_vm._s(_vm.$t('portcalls1.text')))])],1)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }